import React, { useState, useCallback } from 'react'

import { GetProducts } from '@web/walter-lib/api'
import { useBreakpoints } from '@web/walter-ui-kit'
import { CardsViews } from '../types'
import s from './s.module.css'
import Mobile from './Mobile'
import Desktop from './Desktop'
import IssuesModal from '~pages/CardsPage/NewCards/IssuesModal'

interface Props {
    setView: (newView: CardsViews) => void
    setCurrentProduct: (product: GetProducts) => void
    currentProduct?: GetProducts
}

function NewCards({ setView, currentProduct, setCurrentProduct }: Props) {
    const { isTablet, isMobile } = useBreakpoints()
    const [isIssueOpen, setIsIssueOpen] = useState(false)

    const onContinueClick = useCallback(
        (data: GetProducts) => {
            setCurrentProduct(data)

            if (data.issues && data.issues.length > 0) {
                setIsIssueOpen(true)
                return
            }

            setView(CardsViews.NewCard)
        },
        [setCurrentProduct, setView]
    )

    return (
        <>
            <IssuesModal isOpen={isIssueOpen} onClose={() => setIsIssueOpen(false)} product={currentProduct} />
            <div data-pointer="cards_catalog_mobile" className={s.mobile}>
                {(isTablet || isMobile) && <Mobile onContinueClick={onContinueClick} />}
            </div>
            <div data-pointer="cards_catalog_desktop" className={s.desktop}>
                {!(isTablet || isMobile) && <Desktop onContinueClick={onContinueClick} />}
            </div>
        </>
    )
}

export default NewCards
